import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetCurrencyDpListApi } from '@/apis/basics/nation.api';

const { wsCache } = useCache();
const CacheKey = `CurrencyCache`;

export const useCurrency = defineStore('currency_maps', {
	state: (): any => ({
		currencyList: [] as any[],
		currencyMap: {} as any,
	}),
	actions: {
		getName(key: string) {
			if (!(key)) return;
			return this.currencyMap.get(`${key}`) ?? '--';
		},
		getSelectList(key: string, needAll?: false) {
			const selectList = [];
			if (needAll) selectList.push({ value: '', label: '全部' });

			this.currencyList
				.filter((dic: any) => dic.is_enabled == 'Y')
				.forEach((dic: any) => {
					selectList.push({ value: dic.symbol_tandard, label: `${dic.currency_name_cn}(${dic.symbol_tandard})` });
				});

			return selectList;
		},
		async setCurrencyMap() {
			let dataList = wsCache.get(CacheKey);

			if (!dataList) {
				dataList = await this.getDataList();
			}

			this.currencyList = dataList;
			
			/* 组装Map，格式：group_code|value */
			this.currencyMap = new Map();
			dataList.forEach((dic: any) => {
				this.currencyMap.set(`${dic.symbol_tandard}`, dic.currency_name_cn);
			});
		},
		getDataList() {
			return new Promise((resolve) => {
				GetCurrencyDpListApi().then((res: any) => {
					const dicList = res.data || [];
					wsCache.set(CacheKey, dicList);
					resolve(dicList);
				});
			});
		},
	},
});
